var _ellipse, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObPanelExtend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.952,
    cy: 15,
    rx: 14.952,
    ry: 15,
    fill: "#1B365D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.476 15h14.951M15 7.352v14.9",
    stroke: "#fff",
    strokeWidth: 3
  })));
}

export default SvgObPanelExtend;